export default __webpack_public_path__ + "images/icono-urgente.5b5557e978f8f9a285be615488287d58.svg";